import { render } from "./ListOptionTag.vue?vue&type=template&id=f4357e90"
import script from "./ListOptionTag.vue?vue&type=script&lang=js"
export * from "./ListOptionTag.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__